@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<h1 mat-dialog-title>Are you sure you want to cancel subscription?</h1>
<div mat-dialog-content>Your subscription will be active until {{sub?.subscriptionPaidTill | date:"shortDate"}}.</div>
<div mat-dialog-actions>
  <button mat-raised-button [disabled]="loading" (click)="confirmCancel()" color="primary">Confirm</button>
  <button mat-raised-button [disabled]="loading" class="red-icon" mat-dialog-close>Close</button>
</div>